import React, { useEffect, useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import axios from "axios";
import {
  resetPage,
  switchMediaTab,
} from "../../../../_actions/sidebarSliderActions";
import {
  ASSETS_SLIDER_PANEL,
  BRANDKIT_SLIDER_PANEL,
  FOLDERS_SLIDER_PANEL,
  TAB_MY_FOLDERS,
} from "../../constants";
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import AssetsSliderPanel from "./AssetsSliderPanel";
import FoldersSliderPanel from "../foldersPanel/FoldersSliderPanel";
import BrandkitSliderPanel from "./BrandkitSliderPanel/BrandkitSliderPanel";
import {
  wsAddLayer,
  wsAddMusic,
  wsCopyFromStory,
  wsCopyFromTemplate,
  wsUpdateMusic,
} from "../../../../_actions/webSocketAction";
import { updateStoryMusic } from "../../../../_actions/storiesActions";

const AssetsAndBrandkitsSliderPanel = (props) => {
  const signal = axios.CancelToken.source();

  const dispatch = useDispatch();
  const sidebarSlider = useSelector((state) => state.sidebarSlider);
  const activePage = useSelector((state) => state.editor.activePage);
  const story = useSelector((state) => state.story);
  const { t } = useTranslation(["common"]);

  const [selectedTab, setSelectedTab] = useState(
    sidebarSlider.sliderPanelType
      ? sidebarSlider.sliderPanelType
      : ASSETS_SLIDER_PANEL
  );

  useEffect(() => {
    return () => {
      signal.cancel("The user aborted a request.");
    };
  }, []);

  const { canvasRef } = props;

  return (
    <>
      <Box id="text-tab" d={"flex"} flexDirection={"column"} flexGrow={1}>
        <Tabs
          defaultIndex={0}
          onChange={onTabChanged}
          variant={"panel"}
          isFitted
          isLazy
        >
          <TabList w={`calc(100% - 16px)`}>
            <Tab>{t("uploaded_assets")}</Tab>
            <Tab>{t("brandkits")}</Tab>
            <Tab>Folders</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <AssetsSliderPanel canvasRef={canvasRef} />
            </TabPanel>
            <TabPanel>
              <BrandkitSliderPanel canvasRef={canvasRef} />
            </TabPanel>
            <TabPanel>
              <FoldersSliderPanel
                canvasRef={canvasRef}
                onTemplateClick={handleOnTemplateClick}
                onAssetClick={handleOnAssetClick}
                onProjectClick={handleOnProjectClick}
                isDragAndDropContextAvailable
                storyCardTab={TAB_MY_FOLDERS}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </>
  );

  function onTabChanged(selectedIndex) {
    let panelType = ASSETS_SLIDER_PANEL;

    switch (selectedIndex) {
      case 0:
        panelType = ASSETS_SLIDER_PANEL;
        break;
      case 1:
        panelType = BRANDKIT_SLIDER_PANEL;
        break;
      case 2:
        panelType = FOLDERS_SLIDER_PANEL;
        break;
      default:
        panelType = ASSETS_SLIDER_PANEL;
    }
    onSelectTabChange(panelType);
  }

  function onSelectTabChange(k) {
    if (k !== selectedTab) {
      batch(() => {
        dispatch(resetPage(sidebarSlider.searchText));
        dispatch(switchMediaTab(k));
      });
    }
    setSelectedTab(k);
  }

  function handleOnTemplateClick(item) {
    dispatch(wsCopyFromTemplate(activePage.id, item.id));
  }

  function handleOnAssetClick(item) {
    if (item.mime === "shape") {
      if (item.type === "icon") {
        let payload = item;
        if (!payload) {
          return;
        }
        dispatch(wsAddLayer(activePage.id, payload));
      } else {
        dispatch(wsCopyFromTemplate(activePage.id, item.content.id));
      }
    } else if (item.mime === "audio") {
      const payload = {
        ...item,
      };

      batch(() => {
        if (story?.payload?.payload?.music) {
          dispatch(wsUpdateMusic({ music: payload }));
        } else {
          dispatch(wsAddMusic({ music: payload }));
        }
        dispatch(updateStoryMusic(payload));
      });
    } else if (item.mime === "video") {
      dispatch(wsAddLayer(activePage.id, item));
    } else if (item.content) {
      dispatch(wsAddLayer(activePage.id, item));
    }
  }

  function handleOnProjectClick(item) {
    dispatch(wsCopyFromStory(item.id));
  }
};

AssetsAndBrandkitsSliderPanel.propTypes = {
  sidebarSlider: PropTypes.object.isRequired,
};

AssetsAndBrandkitsSliderPanel.defaultProps = {};

export default AssetsAndBrandkitsSliderPanel;
